// src/component/ui/Reveal.jsx
// Apparition au défilement (fade + slide) via IntersectionObserver — léger, sans librairie.
// Usage : <Reveal delay={100}><MonBloc/></Reveal>
import React, { useEffect, useRef, useState } from "react";
import "./reveal.css";

export default function Reveal({
  children,
  as: Tag = "div",
  delay = 0,     // ms
  y = 24,        // décalage vertical initial (px)
  className = "",
  once = true,
}) {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (typeof IntersectionObserver === "undefined") {
      setShown(true);
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            setShown(true);
            if (once) io.disconnect();
          } else if (!once) {
            setShown(false);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [once]);

  return (
    <Tag
      ref={ref}
      className={`reveal ${shown ? "is-in" : ""} ${className}`.trim()}
      style={{ transitionDelay: `${delay}ms`, "--reveal-y": `${y}px` }}
    >
      {children}
    </Tag>
  );
}
